import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  StyledTeamPicture,
  StyledTeamPictureCaption,
  StyledTeamPictureImg,
} from './TeamPicture.styled';

const TeamPicture = ({ teamImage, teamImageCaption }) => (
  <StyledTeamPicture>
    <StyledTeamPictureImg src={teamImage} alt="" />
    <StyledTeamPictureCaption>
      <FontAwesomeIcon icon={faInfoCircle} />
      {teamImageCaption}
    </StyledTeamPictureCaption>
  </StyledTeamPicture>
);

export default TeamPicture;
